import axios from 'axios';

/**
 * Extracts a human-readable message from an API error. The backend returns
 * `{ error: { code, message } }`; surface that message when present, otherwise
 * fall back to the provided default.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { error?: { message?: string } } | undefined;
    const msg = data?.error?.message;
    if (typeof msg === 'string' && msg.length > 0) return msg;
  }
  return fallback;
}
